
const TransactionRow = ({ transactionEmployee }) => {
	return (
		<tr>
			{transactionEmployee.map((field, index) => (
				<td
					key={index}
					className={index > 0 ? "text-center" : "text-left"}
				>
                    {field}
				</td>
			))}
		</tr>
	);
};

export default TransactionRow;
